import script from "./StatusNotificationManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusNotificationManagement.vue?vue&type=script&setup=true&lang=js"

import "./StatusNotificationManagement.vue?vue&type=style&index=0&id=0a5fb6df&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a5fb6df"]])

export default __exports__